<template>
<div class="chapter">
<div class="inner_page">
<p class="otherfm"><a id="page_2"></a>ALSO BY THE AUTHOR</p>
<p class="center">Nightwatchmen</p>
<p class="center">Airships</p>
<p class="center">Ray</p>
<p class="center">The Tennis Handsome</p>
<p class="center">Captain Maximus</p>
<p class="center">Hey Jack!</p>
<p class="center">Boomerang</p>
<p class="center">Never Die</p>
<p class="center">Bats Out of Hell</p>
<p class="center">High Lonesome</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm.vue?279a9c9f